import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import {
  DividerComponent,
  DateComponent,
  HeadingComponent,
  BoxComponent,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-interview-base-box',
  templateUrl: 'interview-base-box.component.html',
  styleUrls: ['./interview-base-box.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [BoxComponent, HeadingComponent, DateComponent, DividerComponent, TranslatePipe],
})
export class InterviewBaseBoxComponent {
  @Input() public question: {
    questionHint?: string;
    questionRequired?: boolean;
    questionTitle: string;
    time?: number | string;
    summary?: boolean;
  };
  @Input() public padding: boolean = true;
  @Input() public invalid: boolean = false;
  @Input() public errorMessage: string | null;
}
